import { countLeadingTrailingSpace } from '@doltech/utils/lib/countLeadingTrailingSpace';
import { Editor, Range } from 'slate';

export const getWrapLinkRange = (editor: Editor, range: Range): Range => {
  // wrapping a link should exclude leading or trailing blank character
  const selectedText = Editor.string(editor, range);
  const countSpace = countLeadingTrailingSpace(selectedText);

  if (countSpace.isAllSpace) {
    return null;
  }

  return {
    anchor: {
      path: range.anchor.path,
      offset: range.anchor.offset + countSpace.leadingSpace,
    },
    focus: {
      path: range.focus.path,
      offset: range.focus.offset - countSpace.trailingSpace,
    },
  } as Range;
};
